import { FormattedMessage } from 'react-intl'
import { useSelector } from 'react-redux'

export default function DiveShopsListTitle() {
  const locationTitle = useSelector((state) => state.locationInfo?.locationTitle)
  return (
    <FormattedMessage defaultMessage='Find the PADI dive shop in { title } that fits your needs by using the filters above or the interactive map. All our dive centers in { title } offer outstanding training, plenty of fun activities and adhere to PADI’s strict quality standards.' values={{ title: locationTitle }} />
  )
}
